import { Type } from 'class-transformer';
import { WFEWorkflowRawDto } from './wfe-workflow-raw-dto';

export class WorkflowDenyParameterDto {
    @Type(() => WFEWorkflowRawDto)
    workflow: WFEWorkflowRawDto;

    denyReason: string;
}
